import { OptionsObject, ProviderContext as SnackbarProviderContext, withSnackbar } from "notistack";
import React from "react";
import { SnackbarNotificationDismissButton } from "./snackbar-notifications";

interface SnackbarNotificationsProps extends SnackbarProviderContext {
  notifications: Array<{
    message: string | React.ReactNode;
    messageKey: string | number;
    messageOptions: OptionsObject;
    messageDismissed: boolean;
  }>;
  removeNotification: (messageKey: string | number) => void;
}

export const SnackbarNotificationsComponent = class extends React.Component<SnackbarNotificationsProps> {
  public openNotifications: Array<string | number> = [];

  public render() {
    return null;
  }

  public componentDidUpdate(prevProps: SnackbarNotificationsProps) {
    const { notifications: prevNotifications } = prevProps;
    const { notifications, enqueueSnackbar, closeSnackbar, removeNotification } = this.props;

    if (prevNotifications !== notifications) {
      notifications.forEach(notification => {
        const { message, messageKey, messageOptions, messageDismissed } = notification;

        if (messageDismissed) {
          closeSnackbar(messageKey);
          return;
        }

        // If notification is not already open..
        if (!this.openNotifications.includes(messageKey)) {
          const handleClose = (key: string | number) => () => {
            closeSnackbar(key);
          };

          // Display snackbar using notistack
          enqueueSnackbar(message, {
            ...messageOptions,
            key: messageKey,
            action: key => <SnackbarNotificationDismissButton onClose={handleClose(key)} />,
            onClose: (event, reason, key) => {
              if (messageOptions.onClose) {
                messageOptions.onClose(event, reason, key);
              }
            },
            onExited: (event, key) => {
              // Remove notification from Redux...
              removeNotification(key);
              // ... and locally
              this.removeOpenNotification(key);
            },
          });

          // Keep track of notifications we've opened
          this.addOpenNotification(messageKey);
        }
      });
    }
  }

  public addOpenNotification = (messageKey: string | number) => {
    this.openNotifications = [...this.openNotifications, messageKey];
  };

  public removeOpenNotification = (messageKey: string | number) => {
    this.openNotifications = this.openNotifications.filter(key => key !== messageKey);
  };
};

export const SnackbarNotifications = withSnackbar(SnackbarNotificationsComponent);
